/**
 * The social providers this account signs in with, by brand name, listed the
 * way the reader's language lists things ("Apple and Google", "Apple e
 * Google"). Read from Clerk's external accounts through the one provider list
 * in @tonnie/foundation; an account outside that list is not named.
 */
import { useUser } from '@clerk/clerk-react';
import { SOCIAL_PROVIDER_NAME, socialProviderOf, type SocialProvider } from '@tonnie/foundation';
import { useLocale } from '@tonnie/locale';
import { useMemo } from 'react';

export function useSignInProviders(): { providers: SocialProvider[]; names: string | null } {
  const { user } = useUser();
  const { intlLocale } = useLocale();

  return useMemo(() => {
    const providers = [
      ...new Set(
        (user?.externalAccounts ?? [])
          .map((account) => socialProviderOf(account.provider))
          .filter((p): p is SocialProvider => p !== null)
      ),
    ];
    const names = providers.length
      ? new Intl.ListFormat(intlLocale, { type: 'conjunction' }).format(
          providers.map((p) => SOCIAL_PROVIDER_NAME[p])
        )
      : null;
    return { providers, names };
  }, [user?.externalAccounts, intlLocale]);
}
